<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedCollector="onChangedCollector"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
              @limitChanged="limitChanged"
        @download="download"/>

    <basic-table
      @Filtred="Filtred"
      :items="detailedTraffic"
      :fields="detailedTrafficFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        collector_id: 0,
        limit: 500,
        download: 0
      },
      requestDetailedTraffic: [],
      detailedTraffic: [],
      detailedTrafficFields: [
        {key: 'timestamp', label: this.$i18n.t('Date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'slink_id', label: this.$i18n.t('Link ID'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Personal account'), sortable: true},
        {key: 'tclass', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 's_addr', label: this.$i18n.t('Sourse'), sortable: true},
        {key: 'd_addr', label: this.$i18n.t('Destination'), sortable: true},
        {key: 'd_pkt', label: this.$i18n.t('Packets'), sortable: true},
        {key: 'd_oct', label: this.$i18n.t('Bytes'), sortable: true},
        {key: 'sport', label: this.$i18n.t('Source port'), sortable: true},
        {key: 'dport', label: this.$i18n.t('Destination port'), sortable: true},
        {key: 'tcp_flags', label: this.$i18n.t('TCP flags'), sortable: true},
        {key: 'proto', label: this.$i18n.t('Protocol'), sortable: true},
        {key: 'tos', label: 'Tos', sortable: true}
      ],
      isGenerateDisabled: false,
      selectCollector: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: true,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      this.getStore.collector_id = this.selectCollector
      if (this.userId) {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_REQUEST_TRAFFIC_DETAILED', this.getStore).then(response => {
        this.requestDetailedTraffic = this.$store.getters['Reports/REQUEST_TRAFFIC_DETAILED']
        let isArr = false
        for (let el of this.requestDetailedTraffic) {
          if (el.is_request_done === isArr) {
            isArr = true
            setTimeout(this.load(), 10000)
            break
          }
        }
        if (!isArr) {
          this.loadDetailedTraffic(isGenerateClick)
        }
      })
    },
    async loadDetailedTraffic (isGen) {
      if (!isGen) {
        await axiosInstance.get('/reports/traffic_detailed?accounting_period_id=0&stop=0&count=0&download=1&limit=' + this.getStore.limit, {timeout: 45000}).then(response => {
          download(response.data, 'report_services_traffic_detailed.csv', 'text/csv')
        })
      } else {
        await this.$store.dispatch('Reports/GET_TRAFFIC_DETAILED', this.getStore).then(response => {
          let tmpDetailedTraffic = this.$store.getters['Reports/TRAFFIC_DETAILED']
          if (tmpDetailedTraffic.traffic_stat_list.length > 0) {
            this.detailedTraffic = tmpDetailedTraffic.traffic_stat_list
            for (let el of this.detailedTraffic) {
              if (!el.tclass) {
                el.tclass = ''
              }
            }
          }
        })
      }

      this.loadDone()
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.detailedTraffic = []
      this.$store.dispatch('Reports/CLEAR_CUSTOM_CHARGES')
      this.getStore.download = 0
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedCollector (value) {
      this.selectCollector = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/detailedTraffic/main.vue